<mat-accordion>
  <div mat-dialog-content class="dialog-content">
    <h2 mat-dialog-title>User's Configuration</h2>
    <mat-form-field>
        <input 
          matInput
          type="text"
          maxlength="15"
          [(ngModel)]="addUserVal"
          [formControl]="searchInput"
          [matAutocomplete]="auto"
          placeholder="Type minimum 4 characters to start the search"
          #searchRef
          (keydown)="filterSearch(searchInput.value)"
        />
        <br>
        <br>
        <!-- <button
          matSuffix
          mat-icon-button
          aria-label="search"
          (click)="filterSearch(searchInput.value)"
        >
        <mat-icon>search</mat-icon>
        </button> -->
        <mat-autocomplete 
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="onSearchSelect($event.option)">
          <mat-option *ngFor="let option of filteredOptions" [value]="option">
            {{ option.fullName}} ({{ option.email }})
          </mat-option>
        </mat-autocomplete> 
      </mat-form-field>    
      &nbsp; &nbsp;  &nbsp;  &nbsp;        
      <button mat-raised-button
      class="btn-addUser" 
      type="submit"
      class="mat-raised-button" color="primary"
      (click)="addUser()"
      [disabled]="!selectedUser">ADD USER</button>
    <br>
    <br>
    <mat-form-field class="alignRight">
      <input
        matInput
        [(ngModel)]="searchVal"
        (keyup)="applyFilter($event.target.value)"
        maxlength="20"
        placeholder="Search"
      />
      <br>
      <br>
    </mat-form-field>
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->           
      
        <!-- name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> User </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>            

         <!-- Email Column -->
       <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
        <td mat-cell *matCellDef="let element"> {{element.email}} </td>
      </ng-container>

      <!-- Profile Column -->
      <ng-container matColumnDef="profile">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Profile </th>
        <td mat-cell *matCellDef="let element"> {{element.profile}} </td>
      </ng-container>
      
       <!-- Status Column -->
       <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let element"> {{element.isActive}} </td>
        <!-- <td ng-class="{'bgRed':  {{element.status}} === 'true', 'bgBlue': {{element.status}} === 'false'}" mat-cell *matCellDef="let element"></td> -->
      </ng-container>  

       <!-- LastLogInTime Column -->
       <ng-container matColumnDef="lastLogInTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Logged In </th>
        <td mat-cell *matCellDef="let element" ng-non-bindable> {{element.lastLogInTime | date:'yyyy.MM.dd HH:mm:ss '}} </td>
      </ng-container>
      
       <!-- options Column -->
  <ng-container matColumnDef="options">
    <th mat-header-cell *matHeaderCellDef>Options</th>
    <td mat-cell *matCellDef="let element">
       <!-- <mat-form-field>
       <mat-label>...</mat-label>
        <mat-select (selectionChange)="someMethod($event.value,element)">
          <mat-option *ngFor="let topping of toppingList" [value]="topping">
            {{topping}}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      <button mat-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="updateStatus($event.value,element)">Change Status</button>
        <button mat-menu-item (click)="changeProfile($event.value,element)">Change Profile</button>
        <button mat-menu-item (click)="deleteUser($event.value,element)">Delete</button>
      </mat-menu>
    </td>
  </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <br>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="10"></mat-paginator>
    </div>
    <!-- ASSIGN PROFILE -->
    <mat-accordion *ngIf="!showUserProfileDialog">
      <div class="userprofile-container" *ngIf="showUserProfileDialog == true">
          <mat-card class="userprofile-details mat-elevation-z3 ">
              <section>
                  <h4 class="userprofile-details-header">Assign User Profiles</h4>
              </section>
              <br>
              <br>
              <section class="userprofile-section">
                  <div>
                      <mat-form-field  class="first-control" appearance="fill">
                          <mat-label>Select a Profile</mat-label>
                          <mat-select name="profile" [(ngModel)]="selectedProfile">
                              <mat-option *ngFor="let item of profiles" [value]="item">{{item.profile}}</mat-option>
                          </mat-select>
                      </mat-form-field>
                  </div>
              </section>
              <br>
              <br>
              <!-- ASSIGN PROFILE BUTTON  -->
              <section class="user-profile-save">
                  <button mat-raised-button
                          class="btn-Cancel"
                          type="submit"
                          (click)="cancel()"
                          >Cancel</button>
                          
                  <button mat-raised-button
                          class="btn-Save"
                          type="submit"
                          (click)="saveProfile()"
                          >Save</button>       
              </section>
          </mat-card>
      </div>
  </mat-accordion>
    <!-- ASSIGN PROFILE  -->
    <div mat-dialog-actions class="alignRight">
      <button mat-raised-button  class="mat-raised-button" color="primary" (click)="closeDialog()">CLOSE</button>     
    </div>
</mat-accordion>